import { render, staticRenderFns } from "./WorkflowFormBuilderRevisionGrantAccessCardDialog.vue?vue&type=template&id=305e8b8b&scoped=true&"
import script from "./WorkflowFormBuilderRevisionGrantAccessCardDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderRevisionGrantAccessCardDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormBuilderRevisionGrantAccessCardDialog.vue?vue&type=style&index=0&id=305e8b8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e8b8b",
  null
  
)

export default component.exports